import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=7a5052b8&scoped=true&"
import script from "./PostForm.vue?vue&type=script&lang=js&"
export * from "./PostForm.vue?vue&type=script&lang=js&"
import style0 from "./PostForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5052b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5052b8')) {
      api.createRecord('7a5052b8', component.options)
    } else {
      api.reload('7a5052b8', component.options)
    }
    module.hot.accept("./PostForm.vue?vue&type=template&id=7a5052b8&scoped=true&", function () {
      api.rerender('7a5052b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/PostForm.vue"
export default component.exports